export default {
	errors: {
		connection: "Erreur de connexion avec le serveur. Vérifiez votre connexion internet.",
		server: "Erreur interne du serveur. Veuillez réessayer plus tard.",
		tooManyRequests: "Trop de requêtes en peu de temps. Veuillez patienter un instant.",
		retry: "Réessayer",
		timeout: "Délai de connexion dépassé. Vérifiez votre connexion internet.",
	},
};
